import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function HaloPolicyLayout({ eyebrow, title, description, updated = "27 July 2026", noIndex = false, children }) {
  return <>
    <SEO title={`${title} — Halo SuperVPN`} description={description} noIndex={noIndex} />
    <section className="border-b border-ink-100 bg-[#031124] text-white">
      <div className="lf-container py-16 md:py-20">
        <div className="lf-eyebrow text-cyan-200">{eyebrow}</div>
        <h1 className="mt-5 max-w-4xl font-display text-5xl font-black leading-tight md:text-6xl">{title}</h1>
        <p className="mt-6 max-w-3xl text-lg leading-relaxed text-slate-200">{description}</p>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[.18em] text-slate-400">Last updated {updated}</p>
      </div>
    </section>
    <section className="lf-section">
      <div className="lf-container grid gap-10 lg:grid-cols-[.3fr_.7fr]">
        <nav aria-label="Halo policies" className="space-y-2 lg:sticky lg:top-28 lg:self-start">
          {[["/halo", "Halo SuperVPN"], ["/halo/account", "Account and billing"], ["/halo/privacy", "Privacy"], ["/halo/terms", "Subscription terms"], ["/halo/support", "Support"], ["/halo/account-deletion", "Delete an account"]].map(([to, label]) => <Link key={to} className="block border-b border-ink-100 py-3 text-sm font-medium text-ink-600 hover:text-ink-900" to={to}>{label}</Link>)}
        </nav>
        <div className="space-y-5">{children}</div>
      </div>
    </section>
  </>;
}

export function HaloPolicySection({ title, children }) {
  return <article className="border border-ink-100 bg-white p-6 md:p-8"><h2 className="font-display text-2xl font-bold">{title}</h2><div className="mt-4 space-y-4 leading-relaxed text-ink-600">{children}</div></article>;
}
